import React, { useRef, useState, useEffect } from "react";
import { Modal, Form, Row, Col, Switch, message, Table, Tag, Typography, Space, Radio, Checkbox, DatePicker, Select } from "antd";
import { Button, Input } from "antd";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined, LockOutlined, MailOutlined, SearchOutlined, CalendarOutlined, CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { GetFormattedDateTime } from "../../utils/DateTimeUtils";


import DynamicSelect from "../customHooks/DynamicSelect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const { Option } = Select;

const AddEditUsers = ({
  visible,
  onCancel,
  modalData,
  CreateSuccessfull,
  CreateFailed,
  id,
  edit = true,
  isContact,
  brokerLabel,
  brokerIdValue,
  brokerNameValue,
}) => {
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [welcomeLoading, setWelcomeLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyType, setHistoryType] = useState(""); // "Password" or "Welcome"
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [cardTimestamps, setCardTimestamps] = useState({ pwd: "N/A", access: "N/A" });
  
  // Course assignment modal states
  const [courseModalVisible, setCourseModalVisible] = useState(false);
  const [courseLoading, setCourseLoading] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [courseSearch, setCourseSearch] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [assignedSelectedCourses, setAssignedSelectedCourses] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [assignedDueDate, setAssignedDueDate] = useState(null);
  
  // Filter states
  const [filterOptions, setFilterOptions] = useState({
    courseTypes: [],
    modes: [],
    languages: [],
    categories: [],
    tags: [],
  });
  const [selectedCourseType, setSelectedCourseType] = useState("Bundle");
  const [defaultAllType, setDefaultAllType] = useState("Bundle");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [summaryExpandedRowKeys, setSummaryExpandedRowKeys] = useState([]);
  const [assignedCourses, setAssignedCourses] = useState([]);
  const [checkupData, setCheckupData] = useState([]);
  const [showConfirmAssignmentModal, setShowConfirmAssignmentModal] = useState(false);

  const getAssignmentCounts = () => {
    const newAssignments = checkupData.filter(d => d.assigned === false).length;
    const alreadyAssigned = checkupData.filter(d => d.assigned === true).length;
    return { newAssignments, alreadyAssigned };
  };

  // Hierarchy states
  const [entities, setEntities] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [entityLoading, setEntityLoading] = useState(false);
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [departmentLoading, setDepartmentLoading] = useState(false);

  const fetchEntities = React.useCallback(async () => {
    setEntityLoading(true);
    try {
      const response = await Axios.get(`/customer/entity/?organization_id=${id}`);
      setEntities(response.data.data.Customers_entity_data || []);
    } catch (error) {
      console.error("Error fetching entities:", error);
    } finally {
      setEntityLoading(false);
    }
  }, [id]);

  const fetchDivisions = React.useCallback(async (entityId) => {
    setDivisionLoading(true);
    try {
      const response = await Axios.get(`/customer/division/?entity_id=${entityId}`);
      const data = response.data.data.Customers_division_data || [];
      setDivisions(data);
      return data;
    } catch (error) {
      console.error("Error fetching divisions:", error);
    } finally {
      setDivisionLoading(false);
    }
  }, []);

  const fetchDepartments = React.useCallback(async (divisionId) => {
    setDepartmentLoading(true);
    try {
      const response = await Axios.get(`/customer/department/?division_id=${divisionId}`);
      const data = response.data.data.Customers_department_data || [];
      setDepartments(data);
      return data;
    } catch (error) {
      console.error("Error fetching departments:", error);
    } finally {
      setDepartmentLoading(false);
    }
  }, []);

  const handleEntityChange = async (value) => {
    formRef.current.setFieldsValue({ division: null, department: null });
    setDivisions([]);
    setDepartments([]);
    if (value) {
      const divs = await fetchDivisions(value);
      if (divs && divs.length > 0) {
        const firstDiv = divs[0].id;
        formRef.current.setFieldsValue({ division: firstDiv });
        const deps = await fetchDepartments(firstDiv);
        if (deps && deps.length > 0) {
          formRef.current.setFieldsValue({ department: deps[0].id });
        }
      }
    }
  };

  const handleDivisionChange = async (value) => {
    formRef.current.setFieldsValue({ department: null });
    setDepartments([]);
    if (value) {
      const deps = await fetchDepartments(value);
      if (deps && deps.length > 0) {
        formRef.current.setFieldsValue({ department: deps[0].id });
      }
    }
  };

  useEffect(() => {
    if (visible && id) {
      fetchEntities();
    }
  }, [visible, id, fetchEntities]);
  const [selectedObjectsCache, setSelectedObjectsCache] = useState([]); // Persistent metadata cache
  const [coursesCurrentPage, setCoursesCurrentPage] = useState(1);
  const [coursesPageSize, setCoursesPageSize] = useState(10);
  const [totalCourses, setTotalCourses] = useState(0);
  
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);

  const formatCardDate = (text) => {
    if (!text) return "N/A";
    const dateObj = new Date(text);
    if (isNaN(dateObj)) return "N/A";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };


  //console.log(modalData?.code);
  const phoneInputRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    setLoading(true);
    const { entity, division, department, ...restValues } = values;
    const payload = {
      ...restValues,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
      ...(entity ? { entity_id: entity } : {}),
      ...(division ? { division_id: division } : {}),
      ...(department ? { department_id: department } : {}),
      course_ids: assignedSelectedCourses.map(key => {
        const keyStr = String(key);
        const extracted = keyStr.includes(':::') ? keyStr.split(':::').pop() : keyStr;
        return Number(extracted);
      }).filter(id => Number.isFinite(id)),
      due_date: assignedDueDate ? `${String(assignedDueDate.date()).padStart(2, '0')}-${String(assignedDueDate.month() + 1).padStart(2, '0')}-${assignedDueDate.year()}` : null
    };
    const normalizedValues = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    try {
      await Axios.post(`/customer/users/`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Added");
    } catch (err) {
      //console.log(err);
      // CreateFailed("Added");
    } finally {
      setLoading(false);
    }
  };
  const onFinishEdit = async (values) => {
    setLoading(true);
    const { entity, division, department, ...restValues } = values;
    const payload = {
      ...restValues,
      status: true,
      organization: id,
      is_contact: isContact || false,
      role: values.role || null,
      ...(entity ? { entity_id: entity } : {}),
      ...(division ? { division_id: division } : {}),
      ...(department ? { department_id: department } : {}),
      course_ids: assignedSelectedCourses.map(key => {
        const keyStr = String(key);
        const extracted = keyStr.includes(':::') ? keyStr.split(':::').pop() : keyStr;
        return Number(extracted);
      }).filter(id => Number.isFinite(id)),
      due_date: assignedDueDate ? `${String(assignedDueDate.date()).padStart(2, '0')}-${String(assignedDueDate.month() + 1).padStart(2, '0')}-${assignedDueDate.year()}` : null
    };
    const normalizedValues = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    try {
      await Axios.put(`/customer/users/?id=${modalData?.id}`, normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      handleCancel();
      CreateSuccessfull("Edited");
    } catch (err) {
      // CreateFailed("Edited");
    } finally {
      setLoading(false);
    }
  };

  const handleSendForgotPassword = async () => {
    if (!modalData?.id || !userInfo?.data?.id) return;
    setPasswordLoading(true);
    try {
      await Axios.get(`/setpasswordmail/${modalData?.id}/?sent_by=${userInfo?.data?.id}`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      messageApi.success("Forgot password mail sent successfully!");
    } catch (err) {
      console.error("Failed to send forgot password mail:", err);
      messageApi.error("Failed to send forgot password mail.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleFetchHistory = async (type) => {
    if (!modalData?.id) return;
    setHistoryType(type);
    setHistoryVisible(true);
    setHistoryLoading(true);
    setCurrentPage(1); // Reset to first page when opening
    setPageSize(5); // Reset to default size
    try {
      const res = await Axios.get(`/customer/lastUpdates/?user_id=${modalData?.id}`);
      if (res?.data?.status === "success") {
        const data = res.data.data;
        if (type === "Password") {
          setHistoryData(data.reset_pwd_history || []);
        } else {
          setHistoryData(data.welcome_mail_history || []);
        }
      }
    } catch (err) {
      console.error("Failed to fetch history:", err);
      messageApi.error("Failed to fetch history.");
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleSendWelcomeMail = async () => {
    if (!modalData?.email || !userInfo?.data?.id) return;
    setWelcomeLoading(true);
    try {
      await Axios.get(`/resendverification/${modalData?.email}/?sent_by=${userInfo?.data?.id}`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      messageApi.success("Welcome mail sent successfully!");
    } catch (err) {
      console.error("Failed to send welcome mail:", err);
      messageApi.error("Failed to send welcome mail.");
    } finally {
      setWelcomeLoading(false);
    }
  };

  const fetchCardTimestamps = React.useCallback(async () => {
    if (!modalData?.id || !edit) return;
    try {
      const res = await Axios.get(`/customer/lastUpdates/?user_id=${modalData?.id}`);
      if (res?.data?.status === "success") {
        const data = res.data.data;
        setCardTimestamps({
          pwd: formatCardDate(data.pwd_lastest_update),
          access: formatCardDate(data.last_login),
        });
      }
    } catch (err) {
      console.error("Failed to fetch card timestamps:", err);
    }
  }, [modalData?.id, edit]);

  useEffect(() => {
    if (visible && edit && modalData?.id) {
      fetchCardTimestamps();
    }
  }, [visible, edit, modalData?.id, fetchCardTimestamps]);

  // Fetch courses for assignment
  const fetchCourses = React.useCallback(async () => {
    if (!userInfo?.data?.organization?.id) return;
    setCourseLoading(true);
    try {
      const typeParam = selectedCourseType ? `&course_type=${selectedCourseType}` : "";
      const searchParam = courseSearch ? `&search=${courseSearch}` : "";
      const res = await Axios.get(
        `/customer/parentcourselibrary/?parent_key_id=${userInfo.data.organization.id}&status=True&page=${coursesCurrentPage}&page_size=${coursesPageSize}${typeParam}${searchParam}`
      );
      setCourseData(res?.data?.results || res?.data || []);
      setTotalCourses(res?.data?.count || (res?.data?.results ? res.data.results.length : 0));
    } catch (err) {
      console.error("Failed to fetch courses:", err);
      messageApi.error("Failed to fetch courses.");
    } finally {
      setCourseLoading(false);
    }
  }, [userInfo?.data?.organization?.id, selectedCourseType, defaultAllType, courseSearch, coursesCurrentPage, coursesPageSize, messageApi]);

  const fetchUserStatusCheck = React.useCallback(async (assignmentItems) => {
    if (!modalData?.id || !edit || assignmentItems.length === 0) {
      setCheckupData([]);
      return;
    }
    try {
      const payload = {
        assignments: [
          {
            user: Number(modalData.id),
            assignments: assignmentItems,
          },
        ],
      };
      const res = await Axios.post(`/learn/userstatuscheck/`, payload, {
        headers: { "X-CSRFToken": getCookie("csrftoken") },
      });
      setCheckupData(res.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch user status check:", err);
    }
  }, [modalData?.id, edit]);

  useEffect(() => {
    if (!courseModalVisible || !edit || !modalData?.id) return;

    // Recursively walk the item tree and collect leaf course entries.
    // - The outermost container's ass_type is inherited for all its leaf descendants.
    // - A "leaf" is an item that is NOT a Bundle or Learningpath (i.e. a plain Course).
    const CONTAINER_TYPES = ['Bundle', 'Learningpath'];
    const expandToLeafCourses = (item, inheritedAssType) => {
      const isContainer = CONTAINER_TYPES.includes(item.course_type);
      if (isContainer && item.children && item.children.length > 0) {
        // Use this container's own ass_type for all its descendants
        const assType = inheritedAssType || item.course_type;
        const results = [];
        item.children.forEach(child => {
          results.push(...expandToLeafCourses(child, assType));
        });
        return results;
      }
      // Leaf node — plain course (or a container with no children, treat as course)
      if (Number.isFinite(Number(item.id))) {
        return [{ course: Number(item.id), ass_type: inheritedAssType || 'Course', ref_id: null }];
      }
      return [];
    };

    const assignmentItems = [];
    selectedCourses.forEach(key => {
      const keyStr = String(key);
      const rawId = keyStr.includes(':::') ? keyStr.split(':::').pop() : keyStr;
      const item = selectedObjectsCache.find(c => String(c.id) === rawId);
      if (!item) return;
      assignmentItems.push(...expandToLeafCourses(item, null));
    });

    const timer = setTimeout(() => {
      fetchUserStatusCheck(assignmentItems);
    }, 500);
    return () => clearTimeout(timer);
  }, [selectedCourses, courseModalVisible, edit, modalData?.id, fetchUserStatusCheck, selectedObjectsCache]);

  // Helper to fetch EVERYTHING matching current filter for "Select All Available"
  const fetchAllFilteredItems = async () => {
    if (!userInfo?.data?.organization?.id) return [];
    try {
      const typeParam = selectedCourseType ? `&course_type=${selectedCourseType}` : "";
      const searchParam = courseSearch ? `&search=${courseSearch}` : "";
      // Use a very high page_size to grab everything in one go for selection purposes
      const res = await Axios.get(
        `/customer/parentcourselibrary/?parent_key_id=${userInfo.data.organization.id}&status=True&page=1&page_size=1000${typeParam}${searchParam}`
      );
      return res?.data?.results || res?.data || [];
    } catch (err) {
      console.error("Failed to fetch all filtered items:", err);
      return [];
    }
  };


  // Reset to page 1 ONLY when the search term itself changes
  useEffect(() => {
    if (!courseModalVisible) return;
    setCoursesCurrentPage(1);
  }, [courseSearch, courseModalVisible]);

  // Fetch courses whenever page, or fetchCourses (which captures search/filter) changes
  useEffect(() => {
    if (!courseModalVisible) return;
    const timer = setTimeout(() => {
      fetchCourses();
    }, courseSearch ? 500 : 0); // debounce only for search
    return () => clearTimeout(timer);
  }, [coursesCurrentPage, courseSearch, courseModalVisible, fetchCourses]);

  const handleOpenCourseModal = () => {
    // When opening, ensure selectedCourses and dueDate match what's actually assigned
    setSelectedCourses([...assignedSelectedCourses]);
    
    // Seed the cache from the already assigned items
    const flatten = (items) => {
      let result = [];
      items.forEach(item => {
        result.push(item);
        if (item.children) result = result.concat(flatten(item.children));
      });
      return result;
    };
    setSelectedObjectsCache(flatten(assignedCourses));
    
    setDueDate(assignedDueDate);
    setCourseModalVisible(true);
  };

  const handleCloseCourseModal = () => {
    setCourseModalVisible(false);
    setCourseSearch("");
    // We don't clear selectedCourses here because they are restored on Open
    // This allows the selection to persist during the modal session
  };

  const handleAssignCourses = async () => {
    if (selectedCourses.length === 0) {
      setAssignedCourses([]);
      setAssignedSelectedCourses([]);
      setAssignedDueDate(null);
      setSelectedObjectsCache([]);
      handleCloseCourseModal();
      return;
    }

    if (edit && checkupData.length > 0) {
      setShowConfirmAssignmentModal(true);
    } else {
      confirmAssignCourses();
    }
  };

  const confirmAssignCourses = () => {
    setShowConfirmAssignmentModal(false);

    // Helper to add unique keys and remove empty children consistently
    const ensureKeys = (items, parentId = "") => {
      return items?.map((item) => {
        const uniqueKey = parentId ? `${parentId}:::${item.id}` : `${item.id}`;
        const newItem = { ...item, tableUniqueKey: uniqueKey };
        if (newItem.children && newItem.children.length > 0) {
          newItem.children = ensureKeys(newItem.children, uniqueKey);
        } else if (newItem.children) {
          delete newItem.children;
        }
        return newItem;
      });
    };

    // Use selectedObjectsCache to build the summary (since it contains metadata from all pages)
    const pruneHierarchy = (items) => {
      const result = [];
      for (const item of items) {
        const isSelected = selectedCourses.includes(item.tableUniqueKey);

        let prunedChildren = null;
        if (item.children) {
          prunedChildren = pruneHierarchy(item.children);
        }

        if (isSelected || (prunedChildren && prunedChildren.length > 0)) {
          const newItem = { ...item };
          if (prunedChildren && prunedChildren.length > 0) {
            newItem.children = prunedChildren;
          } else if (item.children && item.children.length > 0 && isSelected) {
            newItem.children = ensureKeys(item.children, item.tableUniqueKey);
          } else {
            delete newItem.children;
          }
          result.push(newItem);
        }
      }
      return result;
    };

    // Process the full set of selected objects
    // IMPORTANT: Filter for top-level items only (no ::: in uniqueKey)
    // to prevent duplication when using flattened cache.
    const topLevelItems = selectedObjectsCache.filter(item => !String(item.tableUniqueKey).includes(':::'));
    const summaryTableData = pruneHierarchy(ensureKeys(topLevelItems));
    setAssignedCourses(summaryTableData);
    setAssignedSelectedCourses([...selectedCourses]);
    setAssignedDueDate(dueDate);
    setSummaryExpandedRowKeys([]);
    
    messageApi.success(`${selectedCourses.length} course(s) selected.`);
    handleCloseCourseModal();
  };


  // Fetch filter options when modal opens
  useEffect(() => {
    if (courseModalVisible && userInfo?.data?.organization?.id) {
      const fetchFilters = async () => {
        try {
          const res = await Axios.get(`/customer/filter/?organization=${userInfo.data.organization.id}`);
          const data = res?.data || {};
          const filteredCourseTypes = (data.course_types || []).filter(
            (ct) => ct.course_type.toUpperCase() !== "ALL"
          );
          setFilterOptions({
            courseTypes: filteredCourseTypes,
            modes: [],
            languages: [],
            categories: [],
            tags: [],
          });
        } catch (err) {
          console.error('Error fetching filter options', err);
        }
      };
      fetchFilters();
    }
  }, [courseModalVisible, userInfo]);

  // Clear all filters
  const handleClearAll = () => {
    setSelectedCourseType(defaultAllType);
    setCourseSearch("");
    setCoursesCurrentPage(1);
    setSelectedCourses([]);
    setSelectedObjectsCache([]);
    messageApi.info("Filters cleared");
  };


  // Apply all filters to course data
  // Process course data for display (add unique keys and handle hierarchy)
  const getFilteredCourses = () => {
    const processItems = (items, parentId = "") => {
      return items?.map((item) => {
        const uniqueKey = parentId ? `${parentId}:::${item.id}` : `${item.id}`;
        const newItem = { ...item, tableUniqueKey: uniqueKey };

        if (newItem.children && newItem.children.length > 0) {
          newItem.children = processItems(newItem.children, uniqueKey);
        } else if (newItem.children) {
          // Ensure empty children are handled to prevent ghost expand icons
          delete newItem.children;
        }
        return newItem;
      });
    };

    return processItems(courseData);
  };

  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  const formRef = useRef();
  const loadForm = React.useCallback(async () => {
    if (edit && formRef.current) {
      const entityId = modalData?.organization?.entity?.id;
      const divisionId = modalData?.organization?.division?.id;
      const departmentId = modalData?.organization?.department?.id;

      if (entityId) await fetchDivisions(entityId);
      if (divisionId) await fetchDepartments(divisionId);

      const formValues = {
        user_id: modalData?.employee_id,
        first_name: modalData?.first_name,
        last_name: modalData?.last_name,
        job_title: modalData?.job_title,
        location: modalData?.location?.id || null,
        email: modalData?.email,
        phone_number: modalData?.phone_number,
        access: modalData?.access,
        role: Array.isArray(modalData?.org_role)
          ? modalData.org_role.map((r) => r?.id)
          : modalData?.role?.id
            ? [modalData.role.id]
            : [],
        is_contact: modalData?.is_contact || isContact,
        entity: entityId || null,
        division: divisionId || null,
        department: departmentId || null,
      };
      formRef.current.setFieldsValue(formValues);
    }
  }, [edit, modalData, isContact, fetchDivisions, fetchDepartments]);
  useEffect(() => {
    if (modalData && formRef.current) {
      loadForm();
    }
  }, [modalData, loadForm]);
  const [phone, setPhone] = useState("");
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  return (
    <div style={{ padding: "10px" }}>
      {contextHolder}
      <div

        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <p className="modal-heading" style={{ margin: 0 }}>
          {edit ? "Edit User" : "Add User"}
        </p>
        {/* <Button onClick={handleCancel}>
          <CloseOutlined /> Back to List
        </Button> */}
      </div>
      <Form
        onFinish={edit ? onFinishEdit : onFinish2}
        name="complex-form"
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        ref={formRef}
        layout="vertical"
        style={{
          width: "100%",
          marginTop: "3rem",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">User ID</p>}
                  name="user_id"
                  dependencies={["email"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value || getFieldValue("email")) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Either User ID or Email is required")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    className="my-form-input-antd-test"
                    placeholder="Enter ID"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">First Name</p>}>
                  <Form.Item
                    name="first_name"
                    noStyle
                    rules={[
                      { required: true, message: "First name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter First name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Last Name</p>}>
                  <Form.Item
                    name="last_name"
                    noStyle
                    rules={[
                      { required: true, message: "Last name is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Last name"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Job Title</p>}>
                  <Form.Item name="job_title" noStyle>
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter Title"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">Email</p>}
                  name="email"
                  dependencies={["user_id"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (value || getFieldValue("user_id")) {
                          if (value) {
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (emailRegex.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Please enter a valid email address")
                            );
                          }
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Either User ID or Email is required")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    className="my-form-input-antd-test"
                    placeholder="Enter user email"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Phone No.</p>}>
                  <Form.Item noStyle name="phone_number">
                    <PhoneInput
                      // className="my-form-input"
                      ref={phoneInputRef}
                      placeholder="Enter your Phone No."
                      country="us"
                      value={phone}
                      // style={{ width: "27rem" }}
                      onChange={handlePhoneNumberChange}
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Entity</p>} name="entity">
                  <Select
                    className="my-form-input-antd-test"
                    placeholder="Select Entity"
                    loading={entityLoading}
                    onChange={handleEntityChange}
                    allowClear
                  >
                    {entities.map(e => (
                      <Option key={e.id} value={e.id}>{e.entity_name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Division</p>} name="division">
                  <Select
                    className="my-form-input-antd-test"
                    placeholder="Select Division"
                    loading={divisionLoading}
                    onChange={handleDivisionChange}
                    allowClear
                  >
                    {divisions.map(d => (
                      <Option key={d.id} value={d.id}>{d.div_name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <Form.Item label={<p className="my-form-lables">Department</p>} name="department">
                  <Select
                    className="my-form-input-antd-test"
                    placeholder="Select Department"
                    loading={departmentLoading}
                    allowClear
                  >
                    {departments.map(d => (
                      <Option key={d.id} value={d.id}>{d.dep_name}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {edit && (brokerIdValue || brokerNameValue) && (
                <>
                  <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                    <Form.Item
                      label={<p className="my-form-lables">{brokerLabel} ID</p>}
                    >
                      <Input
                        className="my-form-input-antd-test"
                        value={brokerIdValue}
                        readOnly
                        style={{ background: "#f5f5f5" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                    <Form.Item
                      label={
                        <p className="my-form-lables">{brokerLabel} Name</p>
                      }
                    >
                      <Input
                        className="my-form-input-antd-test"
                        value={brokerNameValue}
                        readOnly
                        style={{ background: "#f5f5f5" }}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <DynamicSelect
                  name="role"
                  label="User Role"
                  url={`customer/userroles/${id}/`}
                  initialValue={modalData?.role}
                  takeFromInitial={true}
                  multiple={true}
                />
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Access</p>}>
                  <Form.Item
                    name="access"
                    noStyle
                  // valuePropName="checked"
                  >
                    <Switch checked={modalData?.access} />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                <Form.Item label={<p className="my-form-lables">Is Contact</p>}>
                  <Form.Item
                    name="is_contact"
                    noStyle
                  // valuePropName="checked"
                  >
                    <Switch
                      checked={modalData?.is_contact || isContact}
                      disabled
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                  <Form.Item label={<p className="my-form-lables" style={{ visibility: 'hidden' }}>Action</p>}>
                    <Button
                      type="primary"
                      style={{
                        background: "#f58029",
                        borderColor: "#f58029",
                        width: "200px"
                      }}
                      onClick={handleOpenCourseModal}
                    >
                      Assign Course
                    </Button>
                  </Form.Item>
                </Col>
              {assignedCourses.length > 0 && (
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  {assignedDueDate && (
                    <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontWeight: 600, color: '#262626' }}>Due Date:</span>
                      <Tag color="blue" icon={<CalendarOutlined />} style={{ padding: '2px 10px', borderRadius: '4px' }}>
                        {GetFormattedDateTime(assignedDueDate)}
                      </Tag>
                    </div>
                  )}
                  <div style={{ marginTop: assignedDueDate ? '10px' : '20px' }}>
                    <Table
                      className="course-assignment-table"
                      size="middle"
                      dataSource={assignedCourses}
                      pagination={{
                        pageSize: 5,
                        showSizeChanger: false,
                        showTotal: (total) => `Total ${total} selected`,
                      }}
                      rowKey="tableUniqueKey"
                       columns={[
                        {
                          title: "Course ID",
                          dataIndex: "course_id",
                          key: "course_id",
                          width: 250,
                        },
                        {
                          title: "Course Name",
                          dataIndex: "name",
                          key: "name",
                        },
                        {
                          title: "Course Type",
                          dataIndex: "course_type",
                          key: "course_type",
                          width: 150,
                          render: (type) => (
                            <span style={{ fontWeight: 600, color: '#595959' }}>
                              {type}
                            </span>
                          )
                        },
                        ...(edit ? [{
                          title: "Eligibility",
                          key: "eligibility",
                          width: 100,
                          align: "center",
                          render: (_, record) => {
                            const courseId = String(record.tableUniqueKey).split(':::').pop();
                            const status = checkupData.find(item => String(item.course_id) === String(courseId));
                            if (!status) return <span style={{ color: '#8c8c8c' }}>—</span>;
                            const isEligible = status.assigned === false;
                            return isEligible ? (
                              <CheckOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
                            ) : (
                              <CloseOutlined style={{ color: '#ff4d4f', fontSize: '16px' }} />
                            );
                          }
                        }] : []),
                      ]}
                      bordered
                      expandable={{
                        expandedRowKeys: summaryExpandedRowKeys,
                        onExpand: (expanded, record) => {
                          if (expanded) {
                            setSummaryExpandedRowKeys([...summaryExpandedRowKeys, record.tableUniqueKey]);
                          } else {
                            setSummaryExpandedRowKeys(summaryExpandedRowKeys.filter(key => key !== record.tableUniqueKey));
                          }
                        },
                        indentSize: 20,
                        rowExpandable: (record) => record.children && record.children.length > 0,
                        expandIcon: ({ expanded, onExpand, record }) =>
                          record.children && record.children.length > 0 ? (
                            <span 
                              onClick={e => onExpand(record, e)} 
                              style={{ 
                                cursor: 'pointer', 
                                marginRight: '10px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '22px',
                                height: '22px',
                                border: expanded ? '1px solid #1677ff' : '1px solid #d9d9d9',
                                borderRadius: '6px',
                                color: expanded ? '#1677ff' : '#000000',
                                backgroundColor: '#ffffff',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                transition: 'all 0.3s'
                              }}
                            >
                              {expanded ? '−' : '+'}
                            </span>
                          ) : <span style={{ marginRight: '32px' }} />
                      }}
                    />
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </div>
        {edit && (
          <Row gutter={[12, 12]} style={{ marginTop: "1.5rem", padding: "0 1rem" }}>
            <Col xs={24} md={12}>
              <div
                className="manager-card"
                style={
                  modalData?.is_verified === false
                    ? { opacity: 0.6, pointerEvents: "none" }
                    : {}
                }
              >
                <div className="manager-card-header">
                  Password Manager{" "}
                  {modalData?.is_verified === false && "(Not Verified)"}
                </div>
                <div className="manager-card-body">
                  <div className="manager-info-row">
                    <p className="manager-timestamp">
                      Last Updated At: {cardTimestamps.pwd}
                    </p>
                    <div style={{ width: "100px", height: "22px" }}></div>{" "}
                    {/* Spacer to match Access Manager switch area */}
                  </div>
                  <div className="manager-actions">
                    <Button
                      className="manager-btn"
                      onClick={handleSendForgotPassword}
                      loading={passwordLoading}
                    >
                      <LockOutlined /> Send Forgot Password Mail
                    </Button>
                    <span
                      className="manager-link"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleFetchHistory("Password")}
                    >
                      History of password mails sent
                    </span>
                  </div>


                </div>
              </div>
            </Col>

            <Col xs={24} md={12}>
              <div className="manager-card">
                <div className="manager-card-header">Access Manager</div>
                <div className="manager-card-body">
                  <div className="manager-info-row">
                    <p className="manager-timestamp">
                      Last Access: {cardTimestamps.access}
                    </p>
                    {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100px", justifyContent: "flex-end" }}>
                      <span className="manager-timestamp">Access:</span>
                      <Switch size="small" checked={modalData?.access} />
                    </div> */}
                  </div>
                  <div className="manager-actions">
                    <Button
                      className="manager-btn"
                      onClick={handleSendWelcomeMail}
                      loading={welcomeLoading}
                    >
                      <MailOutlined /> Send Welcome Mail
                    </Button>
                    <span
                      className="manager-link"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleFetchHistory("Welcome")}
                    >
                      History of welcome mails sent
                    </span>
                  </div>


                </div>
              </div>
            </Col>
          </Row>
        )}

        {/* Checkup Result table removed */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                background: "#f58029",
                // fontWeight: "600",
              }}
              className="save-update-btn"
            >
              {edit ? "Update" : "Save"}
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>

      <Modal
        title={
          <div style={{ fontSize: "1.6rem", fontWeight: "700", color: "#34475e" }}>
            {historyType} Mail History
          </div>
        }
        visible={historyVisible}
        onCancel={() => setHistoryVisible(false)}
        footer={null}
        width={700}
        closeIcon={<CloseOutlined style={{ fontSize: "1.5rem" }} />}
      >
        <Table
          className="history-custom-table"
          dataSource={historyData}
          loading={historyLoading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["5", "10", "15", "20"],
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            },
            onShowSizeChange: (current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
          rowKey="id"
          size="small"
          bordered
          rowClassName="history-table-row"
          columns={[
            {
              title: "Sent At",
              dataIndex: "updated_at",
              key: "updated_at",
              render: (text) => GetFormattedDateTime(text, true),
              width: "35%",
            },
            {
              title: "Sent By",
              dataIndex: "sent_by_name",
              key: "sent_by_name",
              width: "30%",
            },
            {
              title: "Email Status",
              dataIndex: "email_status",
              key: "email_status",
              width: "35%",
              render: (text) => {
                const isSuccess = ["Delivery", "Sent"].includes(text);
                const color = isSuccess ? "#52c41a" : "#ff4d4f";
                return (
                  <span style={{ color, fontWeight: "600" }}>
                    {text || "N/A"}
                  </span>
                );
              },
            },
          ]}
        />
      </Modal>

      {/* Course Assignment Modal */}
      <Modal
        open={courseModalVisible}
        onCancel={handleCloseCourseModal}
        width={1600}
        footer={null}
        destroyOnClose
        style={{ top: 20 }}
        bodyStyle={{ height: 'calc(100vh - 100px)', overflowY: 'hidden', padding: 0 }}
        closable={true}
      >
        <style>
          {`
            .filter-sidebar::-webkit-scrollbar {
              width: 5px;
            }
            .filter-sidebar::-webkit-scrollbar-track {
              background: transparent;
            }
            .filter-sidebar::-webkit-scrollbar-thumb {
              background: #d9d9d9;
              border-radius: 10px;
            }
            .filter-sidebar::-webkit-scrollbar-thumb:hover {
              background: #bfbfbf;
            }
            .filter-title {
              font-weight: 700 !important;
              font-size: 16px !important;
              margin-bottom: 1rem !important;
              color: #262626;
            }
            .filter-option-item {
              padding: 6px 12px;
              border-radius: 4px;
              transition: all 0.2s;
              width: 100%;
              cursor: pointer;
            }
            .filter-option-item:hover {
              background-color: #f0f5ff;
            }
            .ant-radio-wrapper {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-right: 0 !important;
              font-size: 14px;
            }
            .ant-collapse-ghost > .ant-collapse-item > .ant-collapse-header {
              padding: 12px 0 !important;
              font-weight: 600;
              color: #262626;
              border-bottom: 1px solid #f0f0f0;
            }
            .ant-collapse-ghost > .ant-collapse-item {
              border-bottom: none !important;
            }
            .ant-collapse-expand-icon {
              order: 1;
              margin-inline-start: auto !important;
            }
            .ant-collapse-header-text {
              order: 0;
            }
            .search-input-container {
              padding: 8px 0;
              margin-bottom: 8px;
            }
            .main-content-column::-webkit-scrollbar {
              width: 6px;
            }
            .main-content-column::-webkit-scrollbar-track {
              background: transparent;
            }
            .main-content-column::-webkit-scrollbar-thumb {
              background: #d9d9d9;
              border-radius: 10px;
            }
          `}
        </style>
        <Row gutter={0} style={{ height: '100%', paddingTop: '45px' }}>
          {/* Filter Sidebar */}
          <Col span={6} className="filter-sidebar" style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', padding: '1.5rem', borderRight: '1px solid #f0f0f0' }}>
            <Typography.Title level={5} className="filter-title">
              Filter
            </Typography.Title>

            {/* Course Types - Top Level */}
            <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0' }}>
              <Radio.Group
                onChange={(e) => {
                  setCoursesCurrentPage(1);
                  setSelectedCourseType(e.target.value);
                  setSelectedCourses([]);
                  setSelectedObjectsCache([]);
                }}
                value={selectedCourseType}
                style={{ width: '100%' }}
              >
                <Space direction="vertical" size={12}>
                  {filterOptions.courseTypes.map(ct => (
                    <div key={ct.course_type} className="filter-option-item">
                      <Radio 
                        value={ct.course_type} 
                        style={{ fontSize: '14px', fontWeight: 500 }}
                      >
                        {ct.course_type}
                      </Radio>
                    </div>
                  ))}
                </Space>
              </Radio.Group>
            </div>

            <div style={{ marginTop: '2rem', textAlign: 'center', paddingBottom: '1rem' }}>
              <Button type="link" onClick={handleClearAll} style={{ color: '#8c8c8c' }}>
                Clear All Filters
              </Button>
            </div>
          </Col>

          {/* Main Content */}
          <Col span={18} className="main-content-column" style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', padding: '1.5rem', paddingRight: '3rem' }}>
            <div style={{ paddingLeft: '0.5rem' }}>
              <Typography.Title level={4} style={{ marginBottom: '1.5rem', marginTop: 0 }}>
                Assign Courses to {formRef.current?.getFieldValue('first_name') || modalData?.first_name} {formRef.current?.getFieldValue('last_name') || modalData?.last_name}
              </Typography.Title>

              <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
                <div style={{ flex: 1, display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <Input
                    placeholder="Search courses by title, ID, or category..."
                    prefix={<SearchOutlined />}
                    value={courseSearch}
                    onChange={(e) => setCourseSearch(e.target.value)}
                    style={{ flex: 1 }}
                  />
                  <Button 
                    onClick={async () => {
                      const isAllSelected = selectedCourses.length > 0 && selectedCourses.length >= totalCourses;
                      if (isAllSelected) {
                        setSelectedCourses([]);
                        setSelectedObjectsCache([]);
                        messageApi.info("All selections cleared");
                      } else {
                        setCourseLoading(true);
                        try {
                          const allItems = await fetchAllFilteredItems();
                          const extractAll = (items) => {
                            let keys = [];
                            let objects = [];
                            items.forEach(item => {
                              // ONLY Select top-level items for the selection keys
                              const uniqueKey = `${item.id}`;
                              keys.push(uniqueKey);
                              const itemWithKey = { ...item, tableUniqueKey: uniqueKey };
                              objects.push(itemWithKey);
                            });
                            return { keys, objects };
                          };
                          const { keys, objects } = extractAll(allItems);
                          setSelectedCourses(keys);
                          setSelectedObjectsCache(objects);
                          messageApi.success(`Selected all ${objects.length} matching items.`);
                        } finally {
                          setCourseLoading(false);
                        }
                      }
                    }}
                    style={{ height: '32px', minWidth: '100px' }}
                  >
                    {selectedCourses.length > 0 && selectedCourses.length >= totalCourses ? "Deselect All" : "Select All"}
                  </Button>
                </div>
                <div style={{ fontSize: '14px', color: '#8c8c8c', whiteSpace: 'nowrap' }}>
                  {totalCourses} course(s)
                </div>
              </div>

              <Table
                className="course-assignment-table"
                dataSource={getFilteredCourses()}
                loading={courseLoading}
                rowKey="tableUniqueKey"
                size="small"
                bordered
                scroll={{ y: 400 }}
                pagination={{
                  current: coursesCurrentPage,
                  pageSize: coursesPageSize,
                  total: totalCourses,
                  showSizeChanger: true,
                  showTotal: (total) => `Total ${total} courses`,
                  onChange: (page, size) => {
                    setCoursesCurrentPage(page);
                    setCoursesPageSize(size);
                  }
                }}
                rowSelection={{
                  selectedRowKeys: selectedCourses,
                  preserveSelectedRowKeys: true,
                  checkStrictly: true, // DECOUPLE parent/child selection
                  columnTitle: (() => {
                    const currentPageData = getFilteredCourses();
                    const curPageTopLevelItems = currentPageData.filter(item => !String(item.tableUniqueKey).includes(':::'));
                    const curPageTopLevelKeys = curPageTopLevelItems.map(item => item.tableUniqueKey);
                    
                    const isAllSelected = curPageTopLevelKeys.length > 0 && curPageTopLevelKeys.every(key => selectedCourses.includes(key));
                    const isIndeterminate = !isAllSelected && curPageTopLevelKeys.some(key => selectedCourses.includes(key));
                    
                    return (
                      <Checkbox
                        checked={isAllSelected}
                        indeterminate={isIndeterminate}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          if (checked) {
                            // Add all top-level keys from current page
                            const newKeys = [...new Set([...selectedCourses, ...curPageTopLevelKeys])];
                            setSelectedCourses(newKeys);
                            
                            // Update cache
                            setSelectedObjectsCache(prev => {
                              const newItems = curPageTopLevelItems.filter(item => !prev.some(p => p.tableUniqueKey === item.tableUniqueKey));
                              return [...prev, ...newItems];
                            });
                          } else {
                            // Remove only top-level keys from current page
                            const remainingKeys = selectedCourses.filter(key => !curPageTopLevelKeys.includes(key));
                            setSelectedCourses(remainingKeys);
                            
                            // Update cache
                            setSelectedObjectsCache(prev => prev.filter(item => remainingKeys.includes(item.tableUniqueKey)));
                          }
                        }}
                      />
                    );
                  })(),
                  onChange: (selectedKeys, selectedRows) => {
                    // Filter for top-level keys ONLY to prevent selection explosion
                    const topLevelKeys = selectedKeys.filter(key => !String(key).includes(':::'));
                    const topLevelRows = selectedRows.filter(row => !String(row.tableUniqueKey).includes(':::'));
                    
                    setSelectedCourses(topLevelKeys);
                    
                    // Update cache: Keep existing items that are still in selectedKeys, 
                    // and add new rows from the current page selection.
                    setSelectedObjectsCache(prevCache => {
                      const stillSelected = prevCache.filter(item => topLevelKeys.includes(item.tableUniqueKey));
                      const newItems = topLevelRows.filter(row => !stillSelected.some(item => item.tableUniqueKey === row.tableUniqueKey));
                      return [...stillSelected, ...newItems];
                    });
                  },
                }}
                expandable={{
                  childrenColumnName: 'children',
                  expandedRowKeys: expandedRowKeys,
                  onExpand: (expanded, record) => {
                    if (expanded) {
                      setExpandedRowKeys([...expandedRowKeys, record.tableUniqueKey]);
                    } else {
                      setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.tableUniqueKey));
                    }
                  },
                  indentSize: 20,
                  rowExpandable: (record) => record.children && record.children.length > 0,
                }}
                columns={[
                  {
                    title: "Course ID",
                    dataIndex: "course_id",
                    key: "course_id",
                    width: 150,
                  },
                  {
                    title: "Course Name",
                    dataIndex: "name",
                    key: "name",
                    width: 300,
                    ellipsis: true,
                  },
                  {
                    title: "Mode",
                    dataIndex: "mode",
                    key: "mode",
                    width: 100,
                  },
                  {
                    title: "Course Type",
                    dataIndex: "course_type",
                    key: "course_type",
                    width: 120,
                  },
                  {
                    title: "Category",
                    dataIndex: "category",
                    key: "category",
                    width: 120,
                  },
                   {
                    title: "Language",
                    dataIndex: "language",
                    key: "language",
                    width: 100,
                  },
                ]}
              />

              {/* Eligibility Results Table — shown when edit mode and checkupData is available */}
              {edit && checkupData.length > 0 && (
                <div style={{ marginTop: '16px' }}>
                  <div style={{ fontWeight: 600, fontSize: '14px', color: '#262626', marginBottom: '8px' }}>
                    Assignment Eligibility Results
                    <span style={{ marginLeft: '8px', fontWeight: 400, color: '#8c8c8c', fontSize: '12px' }}>
                      ({checkupData.filter(d => d.assigned === false).length} eligible,{' '}
                      {checkupData.filter(d => d.assigned === true).length} already assigned)
                    </span>
                  </div>
                  <Table
                    dataSource={checkupData}
                    rowKey={(record) => `${record.course_id}_${record.user_id || 'user'}`}
                    size="small"
                    bordered
                    pagination={{
                      pageSize: 5,
                      showSizeChanger: false,
                      showTotal: (total) => `Total ${total} results`,
                    }}
                    columns={[
                      {
                        title: "Course ID",
                        dataIndex: "course_id",
                        key: "course_id",
                        width: 100,
                      },
                      {
                        title: "Course Name",
                        dataIndex: "course_name",
                        key: "course_name",
                        ellipsis: true,
                      },
                      {
                        title: "Message",
                        dataIndex: "message",
                        key: "message",
                        width: 220,
                        render: (text, record) => record.Message || text || '-',
                      },
                      {
                        title: "Assignment Eligibility",
                        dataIndex: "assigned",
                        key: "assigned",
                        width: 180,
                        align: "center",
                        render: (assigned, record) => {
                          if (assigned === false) {
                            return (
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{
                                  width: '1.8rem', height: '1.8rem', borderRadius: '50%',
                                  backgroundColor: '#52c41a', display: 'flex',
                                  justifyContent: 'center', alignItems: 'center',
                                }}>
                                  <CheckOutlined style={{ color: '#fff', fontSize: '1rem', fontWeight: '700' }} />
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <div style={{
                                width: '1.8rem', height: '1.8rem', borderRadius: '50%',
                                backgroundColor: '#ff4d4f', display: 'flex',
                                justifyContent: 'center', alignItems: 'center',
                              }}>
                                <CloseOutlined style={{ color: '#fff', fontSize: '1rem', fontWeight: '600' }} />
                              </div>
                            </div>
                          );
                        },
                      },
                    ]}
                  />
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '1rem' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#595959' }}>Due Date (Optional)</span>
                    <DatePicker
                      placeholder="Select Due Date"
                      style={{ width: '200px' }}
                      value={dueDate}
                      onChange={setDueDate}
                      format="MMM DD, YYYY"
                    />
                  </div>
                  <Button onClick={handleCloseCourseModal}>Cancel</Button>
                  <Button
                    type="primary"
                    onClick={handleAssignCourses}
                    style={{ background: "#f58029", borderColor: "#f58029" }}
                  >
                    Assign Selected Courses ({selectedCourses.length})
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Modal>

      <Modal
        open={showConfirmAssignmentModal}
        onCancel={() => setShowConfirmAssignmentModal(false)}
        footer={null}
        width={500}
        closable={false}
      >
        <div style={{ padding: "8px 0" }}>
          <h2 style={{ fontWeight: 600, fontSize: "20px", marginBottom: "24px", color: "#262626" }}>
            Confirm assignment
          </h2>
          
          <div
            style={{
              backgroundColor: "#fff",
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
              padding: "16px",
              marginBottom: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  color: "#52c41a",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                {getAssignmentCounts().newAssignments}
              </span>
              <span style={{ color: "#262626", fontSize: "14px" }}>
                New Assignments
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  color: "#faad14",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                {getAssignmentCounts().alreadyAssigned}
              </span>
              <span style={{ color: "#262626", fontSize: "14px" }}>
                Already Assigned
              </span>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#e6f7ff",
              border: "1px solid #91d5ff",
              borderRadius: "4px",
              padding: "12px 16px",
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <InfoCircleOutlined
              style={{
                color: "#1890ff",
                fontSize: "18px",
                flexShrink: 0,
              }}
            />
            <span style={{ color: "#0050b3", fontSize: "14px" }}>
              {getAssignmentCounts().alreadyAssigned > 0 
                ? `Only ${getAssignmentCounts().newAssignments} new assignment(s) will be processed.`
                : `All ${getAssignmentCounts().newAssignments} assignment(s) will be processed.`}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "24px",
            }}
          >
            <Button
              onClick={() => setShowConfirmAssignmentModal(false)}
              style={{
                borderRadius: "4px",
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={confirmAssignCourses}
              style={{
                borderRadius: "4px",
                backgroundColor: "#1890ff",
                borderColor: "#1890ff",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <CheckOutlined />
              Confirm Assignment
            </Button>
          </div>
        </div>
      </Modal>
    </div>

  );
};

const styles = `
.manager-card {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f5ff;
}
.manager-card-header {
  background: #8294ad;
  color: white;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
}
.manager-card-body {
  padding: 12px 16px;
  min-height: 100px;
}
.manager-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.manager-timestamp {
  font-size: 11px;
  color: #1d39c4;
  font-weight: 500;
  margin: 0;
}
.manager-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}
.manager-btn {
  background: #34475e !important;
  color: white !important;
  border: none !important;
  font-size: 11px !important;
  height: 28px !important;
  padding: 4px 8px !important;
  white-space: nowrap;
}
.manager-btn:hover {
  background: #465a73 !important;
}
.manager-link {
  font-size: 11px;
  text-decoration: underline;
  color: #1d39c4;
  white-space: nowrap;
}
.history-table-row {
  background-color: #ededed !important;
}
.history-table-row:hover > td {
  background-color: #ececec !important;
}
.history-custom-table .ant-table-thead > tr > th {
  background-color: #d9d9d9 !important;
  color: #4a4a4a !important;
  font-weight: 700 !important;
}
.course-assignment-table .ant-table-thead > tr > th {
  background-color: #f0f0f0 !important;
  color: #262626 !important;
  font-weight: 700 !important;
  font-family: "Poppins";
  font-size: 1.1rem;
  border-bottom: 2px solid #d9d9d9 !important;
}
.course-assignment-table .ant-table-row:hover > td {
  background-color: #f0f7ff !important;
}
.course-assignment-table .ant-table-row-level-0 {
  background-color: #ffffff;
}
.course-assignment-table .ant-table-row-level-1 {
  background-color: #fafafa;
}
.course-assignment-table .ant-table-row-level-2 {
  background-color: #f5f5f5;
}
.ant-form-item-label {
  padding-bottom: 4px !important;
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

export default AddEditUsers;
 